import axiosClient from "utils/api/axios-client";

const configApi = {
  getConfig: () => {
    const url = "/api/v1/config";
    return axiosClient.get(url);
  },

  update: (config) => {
    const url = `/api/v1/config`;
    return axiosClient.put(url, config);
  },

  updateConfigWithFiles: (formData) => {
    const url = `/api/v1/config`;
    return axiosClient.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // Custom Module Items APIs
  getCustomModuleItems: () => {
    const url = "/api/v1/config/custom-module/items";
    return axiosClient.get(url);
  },

  createCustomModuleItem: (formData) => {
    const url = "/api/v1/config/custom-module/items";
    return axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  updateCustomModuleItem: (itemId, formData) => {
    const url = `/api/v1/config/custom-module/items/${itemId}`;
    return axiosClient.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteCustomModuleItem: (itemId) => {
    const url = `/api/v1/config/custom-module/items/${itemId}`;
    return axiosClient.delete(url);
  },
};

export default configApi;
